const blue = {
  100: '#D2E1FF',
  200: '#145DA033',
  300: '#4F83C5',
  900: '#0D4D89',
  400: '#145DA0',
  500: '#37474f',
  50: '#E6EFF5',
};

export const reds = { 100: '#ffdbdb' };
export const greens = { 100: '#BDE5DD', 500: '#16A085', successBase: '#1FC16B' };
export const textSecondary = '#525866';
export const stateFadedLight = '#F5F7FA';

export const newBlue = {
  500: '#145DA0',
};
export const neutral = {
  500: '#E1E4EA',
  400: '#717784',
  300: '#525866',
  200: '#CACFD8',
  0: '#FFFFFF',
};

export const newGreen = {
  500: '#16A085',
  successDark: '#0D7E68',
  successLight: '#EBFBF8',
  successLightDarker: '#D5F8F1',
  successDarkDarker: '#0D7E68',
  successBase: '#16A085',
  successLight50: '#EBFBF880',
  900: '#0D7E68',
};

export const newRed = {
  100: '#F6CFD2',
  500: '#BF3E48',
  errorDark: '#9D2831',
  errorLight: '#FEEAEC',
  errorLightOther: '#F6CFD2',
  base: '#BF3E48',
  errorBase: '#BF3E48',
  iconRed: '#BF3E48',
  redLight50: '#FEEAEC80',
  900: '#9D2831',
};

const dataGridHeaderGrey = '#F3F4F8';
const dataGridBorderColor = '#C0C7CA';
const dataGridHoverRowColor = '#f5f5f5';
const dataGridSelectedRowColor = '#edf2f8';
const dataGridSelectedRowColorHover = '#e4ebf4';

const noImageBorderColor = '#79747f';
const defaultChipColor = '#575757';

export const bgWeak = '#F5F7FA';
export const bgSoft = '#E1E4EA';

const staticPagesHeaderColor = '#263238';
const staticPagesSubHeaderColor = '#949AA6';
const textSelected = '#007AFF';
const errorLightColor = '#F6CFD2';
const errorDarkColor = '#9D2831';
const successLightColor = '#D2F2E3';
const successDarkColor = '#007AFF';
export const warningDark = '#C06422';
export const warningLight = '#FFF5EE';
export const iconFaded = '#717784';
export const red = '#C44D56';
export const stateInformationLight = '#EEF4FF';

export const redColor = {
  500: '#BF3E48',
};
export const warning = {
  warningLight: '#FFF5EE',
  warningDark: '#C06422',
  warningBase: '#E17F39',
};
export const textPrimary = '#222530';

export {
  blue,
  dataGridBorderColor,
  dataGridHeaderGrey,
  dataGridHoverRowColor,
  dataGridSelectedRowColor,
  dataGridSelectedRowColorHover,
  defaultChipColor,
  errorDarkColor,
  errorLightColor,
  noImageBorderColor,
  staticPagesHeaderColor,
  staticPagesSubHeaderColor,
  successDarkColor,
  successLightColor,
  textSelected,
};
